import * as React from "react";
import type { SVGProps } from "react";
const SvgLinkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="link_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M516.693 656.64 351.147 822.187a107.52 107.52 0 0 1-149.334 0 105.387 105.387 0 0 1 0-149.334L367.36 507.307a42.837 42.837 0 0 0-60.587-60.587L141.227 612.693a191.147 191.147 0 0 0 270.08 270.08L577.28 717.227a42.837 42.837 0 1 0-60.587-60.587zm366.08-515.413a191.573 191.573 0 0 0-270.08 0L446.72 306.773a42.837 42.837 0 1 0 60.587 60.587l165.546-165.547a107.52 107.52 0 0 1 149.334 0 105.387 105.387 0 0 1 0 149.334L656.64 516.693a42.539 42.539 0 0 0-9.344 46.72c2.133 5.163 5.333 9.899 9.344 13.867a42.667 42.667 0 0 0 60.587 0l165.546-165.973a191.573 191.573 0 0 0 0-270.08zM376.747 647.253a42.581 42.581 0 0 0 30.293 12.374 42.667 42.667 0 0 0 30.293-12.374l209.92-209.92a42.837 42.837 0 0 0-60.586-60.586l-209.92 209.92a42.624 42.624 0 0 0 0 60.586z"
    />
  </svg>
);
export default SvgLinkIcon;
